module.exports = __webpack_public_path__ + "static/media/checkout-small.18497ca3.jpg";